import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

const StyledLogoutMenu = styled.button`
  display: flex;
  align-items: start;
  justify-content: start;
  text-align: left;
  padding: 0.65rem 1rem;
  border: none;
  box-sizing: border-box;
  outline: none;
  background-color: transparent;
  color: #7e8299;
  border-radius: 0.475rem;
  display: block;
  font-weight: 600;
  text-transform: capitalize;
  width: 100%;
  transition: color 0.2s ease;

  &:hover,
  &:active,
  &:focus {
    background-color: #f4f6fa;
    color: #274070;
  }
`

const StyledLoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1rem;
`

const LoadingIndicator = () => {
  return (
    <StyledLoadingIndicator>
      <Spinner animation='border' variant='primary' size='sm' />
      <span>Loading..</span>
    </StyledLoadingIndicator>
  )
}

interface Props {
  isLoading: boolean
  onClick: () => void
}

export function LogoutMenu({onClick, isLoading}: Props) {
  const {t} = useTranslation()

  return (
    <StyledLogoutMenu disabled={isLoading} onClick={onClick}>
      {isLoading ? <LoadingIndicator /> : t('sign out')}
    </StyledLogoutMenu>
  )
}
